import React from 'react';
import PropTypes from 'prop-types';

const FormClientError = (props) => {
  const {
    onLoginClick
  } = props;

  return (
    <div className="form-client-error-container">
      <div className="col-lg-12 col-md-12 col-xs-12 text-center">
        <h3>
          The form is not available
        </h3>
        <h3>
          Make sure you are logged into Workast
        </h3>
        <h3>
          <button
            type="button"
            className="btn btn-success"
            onClick={onLoginClick}
          >
            Log in
          </button>
        </h3>
      </div>
    </div>
  );
};

FormClientError.propTypes = {
  onLoginClick: PropTypes.func.isRequired
};

export default FormClientError;
